export default __webpack_public_path__ + "static/agilityventures-e1c784babc65b5b7bca88f84d494aeaa.png";